import removeSeparators from "./removeSeparators";

const autoSeparator = (
    value: string,
    event: React.ChangeEvent<HTMLInputElement>,
    dateFormat = "dmy"
) => {
    if ((event.nativeEvent as InputEvent).inputType === "deleteContentBackward")
        return value;

    const [formatText, separatorText] = dateFormat.split("_");
    const separator =
        separatorText === "dash" ? "-" : separatorText === "dot" ? "." : "/";

    const isIncompletePart = value
        .split(separator)
        .find((valuePart: string) => valuePart.length % 2 !== 0);

    if (!isIncompletePart) {
        value = removeSeparators(value);
        value = value
            .split("")
            .map((char: string, idx: number) => {
                if (
                    (formatText.startsWith("y") && (idx === 3 || idx === 5)) ||
                    ((formatText.startsWith("d") ||
                        formatText.startsWith("m")) &&
                        (idx === 1 || idx === 3))
                ) {
                    char += separator;
                }
                return char;
            })
            .join("");
    }

    return value;
};

export default autoSeparator;
